import cn from 'clsx';
import PropTypes from 'prop-types';
import React from 'react';

import css from '../styles/GradientHeadLine.module.css';

const HEIGHT = {
  SMALL: 'smallHeight',
  REGULAR: 'regularHeight',
};

const GradientHeadLine = ({children, height, isColorLight}) => {
  return (
    <div
      className={cn(css.wrapper, css[height], {
        [css.lightBackground]: isColorLight,
      })}
    >
      {children}
    </div>
  );
};

GradientHeadLine.HEIGHT = HEIGHT;

GradientHeadLine.defaultProps = {
  height: HEIGHT.REGULAR,
  isColorLight: false,
};

GradientHeadLine.propTypes = {
  children: PropTypes.node.isRequired,
  isColorLight: PropTypes.bool.isRequired,
  height: PropTypes.oneOf(Object.values(HEIGHT)).isRequired,
};

export default GradientHeadLine;
